import styled from 'styled-components';

const Container = styled.div`
  opacity: ${({ isVisible }) => (isVisible ? 0.75 : 0.5)};
`;

export default Container;
